import Iconify from "../ui/Iconify";
import {
  MOBILE_SEARCH_ICON_CLASS,
  MobileSearchSideSlot,
} from "./mobile-search-frame";
import {
  PLAY_SEARCH_ICON_PATHS,
  PlaySearchOverlayIcon,
} from "./play-search-overlay-icon";

export const MobileSearchBackButton = ({
  isMainOverlay,
  isPlayOverlay,
  onClose,
}) => (
  <MobileSearchSideSlot
    as="button"
    useBase={isMainOverlay}
    type="button"
    aria-label="검색 닫기"
    className={
      isMainOverlay
        ? ""
        : `flex shrink-0 items-center justify-center ${
            isPlayOverlay ? "h-9 w-9" : "h-10 w-10"
          }`
    }
    onClick={onClose}
  >
    {isPlayOverlay ? (
      <PlaySearchOverlayIcon
        src={PLAY_SEARCH_ICON_PATHS.back}
        className="h-[26px] w-[26px] text-black dark:text-white"
      />
    ) : (
      <Iconify
        icon="lucide:arrow-left"
        className={isMainOverlay ? MOBILE_SEARCH_ICON_CLASS : "!h-6 !w-6"}
      />
    )}
  </MobileSearchSideSlot>
);

export const MobileSearchCameraIcon = () => (
  <Iconify
    icon="solar:camera-outline"
    className="!h-5 !w-5 shrink-0 text-black/70 dark:text-white/70"
  />
);

export const MobileSearchSubmitButton = ({
  isMainOverlay,
  isPlayOverlay,
  hasEmbeddedSearchActions,
}) => (
  <button
    type="submit"
    aria-label="검색"
    className={
      isMainOverlay
        ? "absolute right-9 top-1/2 flex h-9 w-9 -translate-y-1/2 shrink-0 items-center justify-center"
        : hasEmbeddedSearchActions
        ? "flex h-9 w-9 translate-x-px shrink-0 items-center justify-center"
        : ""
    }
  >
    {isPlayOverlay ? (
      <PlaySearchOverlayIcon
        src={PLAY_SEARCH_ICON_PATHS.search}
        className="h-[26px] w-[26px] text-black dark:text-white"
      />
    ) : (
      <Iconify
        icon="lucide:search"
        className={`${isMainOverlay ? MOBILE_SEARCH_ICON_CLASS : "!h-6 !w-6"} text-black dark:text-white`}
      />
    )}
  </button>
);

export const MobileSearchClearButton = ({
  isMainOverlay,
  isPlayOverlay,
  embedded = false,
  ariaLabel = "검색어 지우기",
  onClick,
}) => (
  <button
    type="button"
    aria-label={ariaLabel}
    className={
      embedded
        ? `flex h-9 w-9 shrink-0 items-center justify-center text-black/55 dark:text-white/70 ${
            isMainOverlay
              ? "absolute right-0 top-1/2 h-9 w-9 -translate-y-1/2"
              : ""
          }`
        : "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-black/35 dark:text-white/40"
    }
    onClick={onClick}
  >
    {embedded ? (
      isPlayOverlay ? (
        <PlaySearchOverlayIcon
          src={PLAY_SEARCH_ICON_PATHS.close}
          className="h-[26px] w-[26px]"
        />
      ) : (
        <Iconify icon="lucide:circle-x" className="!h-[26px] !w-[26px]" />
      )
    ) : (
      <Iconify icon="solar:close-circle-bold" className="!h-6 !w-6" />
    )}
  </button>
);
